export const DEFAULT_SEGMENT_COLUMN_WIDTH = 200;
export const DEFAULT_COLUMN_WIDTH = 110;
export const MIN_DATA_COLUMNS_VIEWPORT_WIDTH = DEFAULT_COLUMN_WIDTH * 4;
export const DEFAULT_LIFT_COLUMN_WIDTH = 170;
export const DEFAULT_RESIZE_MIN_WIDTH = 85;
export const CHECKBOX_CELL_PADDING_LEFT = 12;
export const DEFAULT_TOOLTIP_MAX_WIDTH = 250;
export const GROUP_HEADER_MIN_WIDTH = 150;

export const TIME_COMPARISON_HEADER_ROW_HEIGHT = 35;
export const TITLE_ROW_HEIGHT = 42;
export const TITLE_ROW_WITH_SUBTITLE_HEIGHT = 60;
export const FOOTER_ROW_HEIGHT = 42;
export const TABLE_HORIZONTAL_PADDING = 8;
export const GAP_BORDER_SIZE = 1;
export const STICKY_COLUMNS_BORDER_WIDTH = 2;

export const DEFAULT_TABLE_VIEW_N_LIMIT = 12;

export const CssClass = {
  HeaderTitleText: `header-title-text`,
  HeaderSubtitleText: `header-subtitle-text`,
  OverflowWrapper: `overflow-wrapper`,
  ColumnResizeHandle: `column-resize-handle`,
  ScrollableColumns: `scrollable-columns`,
  FixedColumns: `fixed-columns`,
  SearchInput: `search-input`,
};

export const TrackingPropertyName = {
  sortBy: `sortBy`,
  prevSortConfig: `prevSortConfig`,
  numSelected: `numSelected`,
  prevNumSelected: `prevNumSelected`,
};
